import React from 'react'
import './index.scss'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'
import { CatalogTransferView } from '@Entities/rightsholder/catalog-transfer-view'
import {
    getCatalogTransferDecisionForMember,
    getCatalogTransferDecisionLabel,
} from '@App/helpers/get-catalog-transfer-decision'

interface StatusHeaderProps {
    currentTransfer: CatalogTransferView
    currentRightsholderId: number
}

const StatusHeader = ({ currentTransfer, currentRightsholderId }: StatusHeaderProps) => {
    const isSubmittingMember = Number(currentTransfer.submittingMember.ipId) === currentRightsholderId
    const decisionForRightsholder = getCatalogTransferDecisionForMember(currentTransfer, currentRightsholderId)
    const formatDate = (date: string | null | undefined) =>
        date
            ? new Date(date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
              })
            : undefined

    const decisionDate = tableCellSanitizer(formatDate(decisionForRightsholder?.decidedAt))
    const notifiedDate = tableCellSanitizer(formatDate(currentTransfer?.submittedAt))
    const decisionLabel = tableCellSanitizer(
        decisionForRightsholder
            ? getCatalogTransferDecisionLabel(decisionForRightsholder)
            : isSubmittingMember
              ? 'Submitted - Awaiting Confirmation'
              : undefined
    )

    const sourcePublisherNames = currentTransfer.sourcePublishers
        ?.map((publisher) => publisher.publisherName)
        .join(', ')

    return (
        <div className="ct-status-header">
            <div className="ct-review-status">
                <div className="ct-review-status-row">
                    <div className="ct-review-status-stack">
                        <div>
                            <p className="ct-review-status-label">Publisher:</p>
                            <p className="ct-review-status-value">{tableCellSanitizer(sourcePublisherNames)}</p>
                        </div>
                        <div>
                            <p className="ct-review-status-label">Member:</p>
                            <p className="ct-review-status-value">
                                {tableCellSanitizer(currentTransfer.submittingMember.publisherName)}
                            </p>
                        </div>
                        <div>
                            <p className="ct-review-status-label">Writer(s):</p>
                            <p className="ct-review-status-value">{tableCellSanitizer(currentTransfer.writerNames)}</p>
                        </div>
                    </div>
                    <div>
                        <p className="ct-review-status-label">Catalog Transfer ID:</p>
                        <p className="ct-review-status-value">{tableCellSanitizer(currentTransfer.id)}</p>
                    </div>
                    <div>
                        <p className="ct-review-status-label">Date Notified of Transfer</p>
                        <p className="ct-review-status-value">{notifiedDate}</p>
                    </div>
                    <div>
                        <p className="ct-review-status-label">Decision Date:</p>
                        <p className="ct-review-status-value">{decisionDate}</p>
                    </div>
                    <div>
                        <p className="ct-review-status-label">Decision:</p>
                        <p className="ct-review-status-value">{decisionLabel}</p>
                    </div>
                    <div>
                        <p className="ct-review-status-label">Works</p>
                        <p className="ct-review-status-value">{tableCellSanitizer(currentTransfer?.workCount)}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatusHeader
